import { MenuEntry } from '@europrocurement/flexy-components';
import { dossiersBasePath, ordersBasePath } from '@europrocurement/l2d-modules';
import { REALM_INTERN } from '@europrocurement/l2d-keycloak';
import { FORMALITIES_INVOICES_LIST } from '../Factures';

export const FormalitiesMenuEntries: MenuEntry[] = [
    {
        title: 'Formalités',
        icon: 'folders',
        role: REALM_INTERN,
        children: [
            {
                title: 'Dossiers',
                icon: 'folder-magnifying-glass',
                href: `/${dossiersBasePath}`,
            },
            {
                title: 'Commandes',
                icon: 'folder-tree',
                href: `/${ordersBasePath}`,
            },
            {
                title: 'Factures',
                icon: 'file-invoice',
                href: FORMALITIES_INVOICES_LIST,
            },
            {
                title: 'Nouveau Dossier',
                icon: 'folder-plus',
                href: '/newformality/prescripteur',
            },
        ],
    },
];
